import * as React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import { Modal } from 'antd';

import GroupUnits from '../../GroupUnits/GroupUnits';


export default class GroupUnitsModal extends React.Component {
  static propTypes = {
    group: PropTypes.shape().isRequired,
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  render() {
    const { visible, group, onClose } = this.props;
    return (
      <div>
        <Modal
          title={`Подразделения группы ${group.name}`}
          footer={null}
          visible={visible}
          onCancel={onClose}
          destroyOnClose
          width={'930px'}
          bodyStyle={{
            overflow: 'hidden',
          }}
          getContainer={() => ReactDOM.findDOMNode(this)}
        >
          <GroupUnits group={group} />
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Groups/GroupPage/GroupInfo/GroupUnitsModal.js